import { render, staticRenderFns } from "./CallModal.vue?vue&type=template&id=2beb3f26&scoped=true"
import script from "./CallModal.vue?vue&type=script&lang=js"
export * from "./CallModal.vue?vue&type=script&lang=js"
import style0 from "./CallModal.vue?vue&type=style&index=0&id=2beb3f26&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2beb3f26",
  null
  
)

export default component.exports